<template>
    <form @submit.prevent="save" class="clearfix pb-4">
        <top-nav-bar :goto="backPath"></top-nav-bar>

        <template v-if="step === 'information'">
            <form-group label="Flight #" name="flight_no" :required="true">
                <div class="select">
                    <select name="flight_no" v-model="report.flight_no" class="input">
                        <option value="">Select a flight #</option>
                        <option v-for="flight in flights" :value="flight">
                            {{flight}}
                        </option>
                    </select>
                </div>
            </form-group>

            <form-group label="STD" name="std" :required="true">
                <time-field
                    id="std"
                    class="input"
                    name="std"
                    v-model="report.std"
                />
            </form-group>

            <form-group label="Date" name="date" :required="true">
                <datepicker
                    placeholder="Select date"
                    id="date"
                    name="date"
                    :min-date="minStartDate"
                    v-model="report.date"
                />
            </form-group>

            <form-group label="SCC L1" name="scc_l1" :required="true">
                <div class="select">
                    <select name="scc_l1" id="scc_l1" class="input" v-model="report.scc_l1">
                        <option value="">Select crew</option>
                        <option v-for="user in users" :value="user.id">{{user.employee_id}} - {{user.name}}</option>
                    </select>
                </div>
            </form-group>

            <form-group label="SCC L4" name="scc_l4" :required="true">
                <div class="select">
                    <select name="scc_l4" id="scc_l4" class="input" v-model="report.scc_l4">
                        <option value="">Select crew</option>
                        <option v-for="user in users" :value="user.id">{{user.employee_id}} - {{user.name}}</option>
                    </select>
                </div>
            </form-group>
        </template>

        <template v-if="step === 'incident'">
            <h4>Incident</h4>

            <form-group label="Safety" name="safety">
                <input type="text" name="safety" class="input" v-model="report.safety">
            </form-group>

            <form-group label="Security" name="security">
                <input type="text" name="security" class="input" v-model="report.security">
            </form-group>

            <form-group label="Medical" name="medical">
                <input type="text" name="medical" class="input" v-model="report.medical">
            </form-group>

            <form-group label="Crew Injury" name="crew_injury">
                <input type="text" name="crew_injury" class="input" v-model="report.crew_injury">
            </form-group>
        </template>

        <template v-if="step === 'deviation'">
            <h4>Deviation</h4>
            <form-group label="Deviation" name="deviation">
                <input type="text" name="deviation" class="input" v-model="report.deviation">
            </form-group>

            <form-group label="SOP" name="sop">
                <input type="text" name="sop" class="input" v-model="report.sop">
            </form-group>

            <form-group label="Catering" name="catering">
                <input type="text" name="catering" class="input" v-model="report.catering">
            </form-group>

            <form-group label="Cabin" name="cabin">
                <input type="text" name="cabin" class="input" v-model="report.cabin">
            </form-group>

            <form-group label="Service and Product" name="service_and_product">
                <input type="text" name="service_and_product" class="input" v-model="report.service_and_product">
            </form-group>

            <form-group label="Customer Complaints" name="customer_complaints">
                <input type="text" name="customer_complaints" class="input" v-model="report.customer_complaints">
            </form-group>
        </template>

        <template v-if="step === 'description'">
            <h4>Description</h4>
            <form-group label="Description of incident/deviation" name="description">
                <textarea name="description" class="input" id="description" rows="10" v-model="report.description"></textarea>
            </form-group>

        </template>

        <div class="block md:inline-flex md:float-right">
            <button class="btn btn--colored__blue w-full" type="submit" v-html="buttonText"></button>
        </div>
    </form>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates'
import NeedsUsers from '@/mixins/NeedsUsers'
import HasSteps from '@/mixins/HasSteps'
import IsReport from '@/mixins/IsReport'
import SetsReportData from '@/mixins/SetsReportData'
export default {
    mixins: [InteractsWithDates, NeedsUsers, HasSteps, IsReport, SetsReportData],

    data() {
        return {
            type: 'incident-deviation',
            steps: [
                {name: 'Information', id: 'information'},
                {name: 'Incident', id: 'incident'},
                {name: 'Deviation', id: 'deviation'},
                {name: 'Description', id: 'description'},
            ],
            report: {
                flight_no: '',
                std: '',
                date: '',
                scc_l1: null,
                scc_l4: null,
                safety: '',
                security: '',
                medical: '',
                crew_injury: '',
                deviation: '',
                sop: '',
                catering: '',
                cabin: '',
                service_and_product: '',
                customer_complaints: '',
                description: ''
            }
        }
    },

    created() {
        if(this.$parent.reportData) {
            this.setData(this.$parent.reportData, ['flight_no', 'std', 'date'])
            this.setData(this.$parent.reportData.scc_l1, 'scc_l1', 'id')
            this.setData(this.$parent.reportData.scc_l4, 'scc_l4', 'id')
            this.setData(this.$parent.reportData.content, ['safety', 'security', 'medical', 'crew_injury'], 'incident')
            this.setData(this.$parent.reportData.content, [
                'deviation', 'sop', 'catering', 'cabin',
                'service_and_product', 'customer_complaints'
            ], 'deviation')
            this.setData(this.$parent.reportData.content, 'description')
        }
    },

    computed: {
        flights() {
            return this.$parent.flights
        },
    },
}
</script>
